var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2122_58152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C8.85652 14.5 10.637 13.7625 11.9497 12.4497C13.2625 11.137 14 9.35652 14 7.5C14 5.64348 13.2625 3.86301 11.9497 2.55025C10.637 1.2375 8.85652 0.5 7 0.5C5.14348 0.5 3.36301 1.2375 2.05025 2.55025C0.737498 3.86301 0 5.64348 0 7.5C0 9.35652 0.737498 11.137 2.05025 12.4497C3.36301 13.7625 5.14348 14.5 7 14.5ZM7.81375 6.2645L6.93875 10.3814C6.8775 10.6789 6.96413 10.8477 7.20475 10.8477C7.3745 10.8477 7.63088 10.7865 7.805 10.6325L7.728 10.9965C7.47687 11.2993 6.923 11.5197 6.44613 11.5197C5.831 11.5197 5.56938 11.1505 5.73913 10.3656L6.38487 7.33113C6.44088 7.07475 6.39013 6.982 6.13375 6.91988L5.73913 6.849L5.81087 6.51562L7.81462 6.2645H7.81375ZM7 5.3125C6.76794 5.3125 6.54538 5.22031 6.38128 5.05622C6.21719 4.89212 6.125 4.66956 6.125 4.4375C6.125 4.20544 6.21719 3.98288 6.38128 3.81878C6.54538 3.65469 6.76794 3.5625 7 3.5625C7.23206 3.5625 7.45462 3.65469 7.61872 3.81878C7.78281 3.98288 7.875 4.20544 7.875 4.4375C7.875 4.66956 7.78281 4.89212 7.61872 5.05622C7.45462 5.22031 7.23206 5.3125 7 5.3125Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2122_58152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.62a51db07b565485adb7aa8f69d9dceb.svg";
export { ForwardRef as ReactComponent };